import { TemplateRef } from '@angular/core';
import { z } from 'zod';
import { Table, TableLazyLoadEvent } from 'primeng/table';
import { ToolbarOptions } from '@src/app/components/toolbar/types';

import { CaptionOptions } from './components/caption/types';
import { RowMenuOptions } from './components/row-menu/types';
import { DialogOptions } from './components/dialog/types';

// TODO: реализовать наследование от Table из 'primeng/table'
export interface TableOptions<
  ApiDataType,
  FormDataType,
  CreateComponent,
  EditComponent,
  ViewComponent,
  MassEditComponent,
  AddComponent,
> {
  useQueryParams?: boolean;
  useStorage?: boolean;
  tableName?: string;
  zodObject?: z.ZodObject<any>;
  value?: ApiDataType[];
  dataKey?: string;
  columns?: string[];
  excludeColumns?: string[];
  columnsTemplates?: ColumnsTemplates;
  first?: number;
  rows?: number;
  totalRecords?: number;
  sortField?: string;
  sortOrder?: number;
  paginator?: boolean;
  selecting?: boolean; // TODO: убрать. завязаться на selectionMode
  loading?: boolean;
  loadingTimer?: boolean;
  selectionMode?: Table['selectionMode'];
  headerFilterAlwaysVisible?: boolean;
  toolbarOptions?: ToolbarOptions;
  captionOptions?: CaptionOptions;
  rowMenuOptions?: RowMenuOptions;
  columnOptions?: ColumnOptions;
  currentPageReportTemplate?: string;
  addDialogOptions?: DialogOptions<AddComponent>;
  createDialogOptions?: DialogOptions<CreateComponent>;
  editDialogOptions?: DialogOptions<EditComponent>;
  viewDialogOptions?: DialogOptions<ViewComponent>;
  massEditDialogOptions?: DialogOptions<MassEditComponent>;
  onLazyLoad?: (event: TableLazyLoadEvent) => Promise<void>;
  onStopLoad?: () => void;
  onAdd?: () => Promise<ApiDataType[] | undefined>;
  onCreate?: () => Promise<ApiDataType | undefined>;
  // onCopy?: (event: ApiDataType) => Promise<ApiDataType | undefined>;
  onEdit?: (event: ApiDataType) => Promise<ApiDataType | undefined>;
  onMassEdit?: (event: ApiDataType) => Promise<ApiDataType[] | undefined>;
  onDelete?: (event: ApiDataType[]) => Promise<void>;
  onRestart?: (event: ApiDataType[]) => Promise<void>;
  onResend?: (event: ApiDataType[]) => Promise<void>;
  onTurnOff?: (event: ApiDataType[]) => Promise<void>;
  onTurnOn?: (event: ApiDataType[]) => Promise<void>;
  onStart?: (event: ApiDataType[]) => Promise<void>;
  onStop?: (event: ApiDataType[]) => Promise<void>;
}

export interface FilterOptions<FilterType> {
  visible?: boolean;
  value?: FilterType;
}

export interface ColumnOptions {
  sorting?: boolean;
  excludeFieldsSorting?: string[];
  filtering?: boolean;
  excludeFieldsFiltering?: string[];
  columnFilterTypesFields?: Record<string, ColumnFilterTypeEnum>;
  columnFilterDictionaryFields?: string[];
}

export type ColumnFilterTypeEnum = 'text' | 'numeric' | 'date';
export const ColumnFilterTypeEnum = {
  String: 'text' as ColumnFilterTypeEnum,
  Number: 'numeric' as ColumnFilterTypeEnum,
  Date: 'date' as ColumnFilterTypeEnum,
  Object: 'text' as ColumnFilterTypeEnum,
  Undefined: 'text' as ColumnFilterTypeEnum,
  Function: 'text' as ColumnFilterTypeEnum,
  Boolean: 'text' as ColumnFilterTypeEnum,
};

export interface ColumnsTemplates {
  [key: string]: TemplateRef<any> | undefined;
}

export interface Column {
  field: string;
  header: string;
  customExportHeader?: string;
}
